import { forwardRef } from 'react'

import { cn } from 'src/shared/utils/cn'

interface DropdownPredictionContainerProps {
  children: React.ReactNode
  align?: 'top' | 'bottom'
}

const DropdownPredictionContainer = forwardRef<HTMLDivElement, DropdownPredictionContainerProps>(
  ({ children, align = 'top' }, ref) => {
    return (
      <div
        ref={ref}
        id="location-predictions"
        role="listbox"
        className={cn(
          'absolute left-[-5px] z-0 w-[510px] rounded-[33px] bg-white p-5 shadow-[0_0_15px_0_rgba(27,48,41,0.1)]',
          align === 'top' ? 'top-[-5px] pt-[85px]' : 'bottom-[-5px] pb-[85px]',
        )}
      >
        <ul
          className="flex max-h-[320px] flex-col-reverse gap-0 overflow-y-auto 
      [&::-webkit-scrollbar-thumb]:rounded-full
    [&::-webkit-scrollbar-thumb]:bg-[#1B3029]
      [&::-webkit-scrollbar-track]:my-4
      [&::-webkit-scrollbar-track]:rounded-full
    [&::-webkit-scrollbar-track]:bg-[#D8D8D6]
      [&::-webkit-scrollbar]:w-[3px]"
        >
          {children}
        </ul>
      </div>
    )
  },
)

DropdownPredictionContainer.displayName = 'DropdownPredictionContainer'

export default DropdownPredictionContainer
